import { ReactComponent as UserSVG } from '../../../assets/image/user.svg';

const UserIcon = () => (
    <UserSVG height={40} style={{ marginLeft: 13, marginRight: 20 }} />
);

export default UserIcon;
